/**
* In this file contains the physician register screen UI designs and register forms functionality
**/
import { Link,useNavigate } from 'react-router-dom';
import { useState } from 'react';
import constantVariables from './../../dataset/constantVariables.json';
import * as Yup from 'yup';
import { validate } from './../../services/ValidationService';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Autocomplete from 'react-google-autocomplete';
import { filterGeoLocation } from './../../services/UtilsService';
import ApiService from './../../services/ApiService';
import { toast } from 'react-toastify';

//Register page
function Register() {
  
    //Intial state declaration
	const [data,setData]=useState({});
	const [error,setError]=useState({});
	const [isValid,setIsValid]=useState(true);
	const navigate = useNavigate();
	
	//validate patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
	/** 
	* Validation schema for Physician Fields
	* @first_name - required field and pass the physician first_name
	* @last_name - required field and pass the physician last_name
	* @email - required field and should be in correct physician email format 
	* @mobileNumber - required field and pass the physician mobileNumber
	* @specialist - required field and pass the physician specialist
	* @department - required field and pass the physician department
	* @city pass the physician city in the string value
	* @state pass the physician state in the string value
	* @gender pass the physician gender in the string value
	* @zipcode pass the physician zipcode in the string value
	**/
   const fields = [
    { name: 'first_name', validation: Yup.string().required(constantVariables.error.required) },
    { name: 'last_name', validation: Yup.string().required(constantVariables.error.required) },
	{ name: 'email', validation: Yup.string().test('Invalid email address', constantVariables.error.email, (value) => { return emailPattern.test(value); }).required(constantVariables.error.email)},
	{ name: 'mobileNumber', validation: Yup.string().required(constantVariables.error.required) },
	{ name: 'specialist', validation: Yup.string().required(constantVariables.error.required)},
	{ name: 'department', validation: Yup.string().required(constantVariables.error.required)},
	{ name: 'city', validation: Yup.string().required()},
	{ name: 'state', validation: Yup.string().required() },
	{ name: 'gender', validation: Yup.string().required() },
	{ name: 'zipcode', validation: Yup.string()
        .min(5,  constantVariables.error.zipcode).matches(/^\d+$/, constantVariables.error.numberOnly).required() },
   ];
   
   /** 
   * To handle input change event 
   * @e - we get the event details from the Change action
   **/
   const handleChange=async(e)=>{
	   const {name,value}=e.target;
	   e.preventDefault();
	   setData({...data,[name]:value});
	   const Errors=await validate({[name]:value},fields);
	   setError({...error,[name]:Errors[name]});
   }
   
    /** 
  * To check phone number valid or not 
  * @value - we pass the actual phone number
  * @country - we pass the countryCode
  * @e - we get the event details from the onChange action
  * @formattedValue - we pass the country formatted Value
  **/
   const handlePhone=async (value,country:any,e,formattedValue)=>{
	   const {format, dialCode} = country;
		setData({...data,[e.target.name]:formattedValue.split("+"+dialCode+" ")[1],countryCode:'+'+dialCode});
      const Errors = await validate({ [e.target.name]: formattedValue }, fields);
      setError({...error,[e.target.name]:Errors[e.target.name]});
      if (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value))) {
	       setIsValid(true);
	  }else{
		   setIsValid(false);
	  }
   }
   
   /** 
  * To change city input 
  * @e - we get the event details form the change action
  **/
  const changeCity=async(e)=>{
         const { value }=e.target;
		 var obj={};
		 if(value.trim().length ===0){
			 obj={city:'',state:''};
		 }else{
		     obj={city:value};
		 }
		 setData((data)=>({...data,...obj}));
		 const Errors = await validate({ city:value }, fields);
	     setError({...error,city:Errors['city']});
  }
  
  /** 
  * To select city input 
  * @e - we get the event details from the Select action
  **/
  const selectCity=async(e)=>{ 
	     var location= await filterGeoLocation(e);
		   await setData((data)=>({...data,...location}));
  }
   
    /** 
   * To handle the form submit event 
   * @e - we get the event details from the form submit action
   **/	
  const handleSubmit=async(e)=>{
	  e.preventDefault();
	  const Errors=await validate(data,fields)
	  setError(Errors);
     if(!Object.keys(Errors).length && isValid){
			var response = await ApiService.physicianSignup(data);
		  if(response.status===200){
			toast.success(response?.data?.message);
			navigate('/login/physician');  
		  }else{
			  toast.error(response?.data?.message);
		  }
	  }	  
  }
  
  return (
  <>
    {/** Register page **/}
<main className="login-sec">
    <div className="container">

      <section className="register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div className="container">
		{/** Logo **/}
          <div className="row justify-content-center">
            <div className="col-lg-12">
				<div className="d-flex justify-content-center pb-5">
					<Link to='/' className="login-logo d-flex align-items-center">
						<img src="/assets/img/nurture-logo.svg" alt="lo" />
					</Link>
				</div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
				<div className="wrap d-md-flex">
					<img src="/assets/img/registration-img.jpg" alt="lo" />
					
					{/** Register Form **/}				
					<div id="loginForm">
						<h1>{constantVariables.auth.register}</h1>
						<h5>{constantVariables.auth.registerTitle}</h5>
						
						<form autoComplete="off">
						 
						  <div className="mb-3 row">
						  <div className="col-6 form-group">
							<label className="mb-1">{constantVariables.profile.firstName}</label>
							<input type="text" onChange={handleChange}  value={data.first_name?data.first_name:''} name="first_name" className="form-control" placeholder={constantVariables.profile.firstName} />
						   {error && error.first_name && <span className="required">{error.first_name}</span>}
						  </div>
						  <div className="col-6 form-group">
							<label  className="mb-1">{constantVariables.profile.lastName}</label>
							<input type="text" onChange={handleChange}  value={data.last_name?data.last_name:''} name="last_name" className="form-control" placeholder={constantVariables.profile.lastName} />
							{error && error.last_name && <span className="required">{error.last_name}</span>}
						  </div>
						  </div>
						  <div className="mb-3 form-group">
							<label  className="mb-1">{constantVariables.profile.emailAddress}</label>
							<input onChange={handleChange}  value={data.email?data.email:''} name="email" type="text" className="form-control" placeholder="Enter email address" />
							<i className="iconly-Light-Message"></i>
							{error && error.email && <span className="required">{error.email}</span>}
						  </div>
						  <div className="mb-3 form-group">
								<label className="mb-1">{constantVariables.profile.phoneNumber}</label>
							 <PhoneInput
							  inputClass="custom-phone-input"
							  inputProps={{
							  name: 'mobileNumber',
							  style: { width: '100%'}
							  }}
							  country={'us'}
							   onChange={handlePhone}
							/>
							{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
							{!isValid && !error.mobileNumber && <span className="required">Enter Valid Number</span>}
							</div>
					     <div className="mb-3 row">
						  <div className="col-6 form-group">
								<label className="mb-1">{constantVariables.profile.specialty}</label>
								<input onChange={handleChange}  value={data.specialist?data.specialist:''} name="specialist" type="text" className="form-control" placeholder="Enter The specialty"  />
							   {error && error.specialist && <span className="required">{error.specialist}</span>}
							</div>
							<div className="col-6 form-group">
								<label className="mb-1">{constantVariables.profile.department}</label>
								<input onChange={handleChange}  value={data.department?data.department:''} name="department" type="text" className="form-control" placeholder="Enter The department"  />
								{error && error.department && <span className="required">{error.department}</span>}
							</div>
							</div>

							<div className="mb-3 form-group">
								<label className="mb-1">{constantVariables.profile.gender}</label>
								<select name="gender" value={data?.gender?data.gender:''} onChange={handleChange} className="form-select mb-3">
								<option value='' disabled>Select gender</option>
								<option value="0" >{constantVariables.profile.male}</option>
								<option value="1" >{constantVariables.profile.female}</option>
								</select>
								{error && error.gender && <span className="required">{error.gender}</span>}
							</div>
							<div className="mb-3 form-group">
								<label className="mb-1">{constantVariables.profile.addressOne}</label>
								<input onChange={handleChange}  value={data.address_one?data.address_one:''} name="address_one" type="text" className="form-control" placeholder="Enter The Address Line 1"  />
								{error && error.address_one && <span className="required">{error.address_one}</span>}
							</div>
							<div className="mb-3 form-group">
								<label className="mb-1">{constantVariables.profile.addressTwo}</label>
								<input onChange={handleChange}  value={data.address_two?data.address_two:''} name="address_two" type="text" className="form-control" placeholder="Enter The Address  Line 2" />
								{error && error.address_two && <span className="required">{error.address_two}</span>}
							</div>
							<div className="mb-3 form-group">
								<label className="mb-1">{constantVariables.profile.city} </label>
								<Autocomplete
								value={data?.city?data.city:''}
								className="form-control" 
								placeholder="Enter The City" 
								onChange={changeCity}
								 onPlaceSelected={selectCity}
								types={['(cities)']}		
								/>
								{error && error.city && <span className="required">{error.city}</span>}
							</div>
							<div className="mb-3 form-group">
								<label className="mb-1">{constantVariables.profile.state} </label>
								<input onChange={handleChange} readOnly  value={data.state?data.state:''} name="state" type="text" className="form-control" placeholder="Enter The State" />
								{error && error.state && !data.state && <span className="required">{error.state}</span>}
						   </div>
						   <div className=" form-group">
								<label className="mb-1">{constantVariables.profile.zipCode} </label>
								<input onChange={handleChange}  value={data.zipcode?data.zipcode:''} name="zipcode" type="text" className="form-control" placeholder="Enter The Zip Code" />
								{error && error.zipcode && <span className="required">{error.zipcode}</span>}
							</div>
						  <div className="my-5">
							<button type="button" onClick={handleSubmit}  className="btn btn-tmBlue w-100">{constantVariables.auth.register}</button>
						  </div>
						</form>
						<div className="footer-text">
							<p>Already have an account?  <Link to='/login/physician' className="ml-1">{constantVariables.auth.loginNow}</Link></p>
						</div>
					</div>
					{/** End register Form **/}
				</div>
            </div>
          </div>
        </div>

      </section>

    </div>
  </main>
  {/** Register page end **/}
  </>
  );
}


export default Register;
